export * from './api-models/CompleteResult';
export * from './api-models/NewResult';
export * from './api-models/ScanSource';
export * from './api-models/ScanResult';
export * from './CopyleaksReportConfig';
export * from './CopyleaksTextConfig';
export * from './ResultsSettings';
export * from './Matches';
export * from './HtmlHelper';
export * from './ReportStatistics';
